import React from "react";
import classes from '../main.module.css'
import Carousel from "react-grid-carousel";

const CaseStudies = () => {

    const caseStudies = [
        {
            title: "NOTEZ",
            type: "EDUCATION",
            image: "/images/notez_icon.webp",
            link: "https://play.google.com/store/apps/details?id=com.feline.notes"
        },
        {
            title: "REMIND",
            type: "PRODUCTIVITY",
            image: "/images/remind_icon.webp",
            link: "https://play.google.com/store/apps/details?id=com.feline.remind"
        },
        {
            title: "CLIPIN",
            type: "BOOKS AND REFERENCE",
            image: "/images/clipin_icon.webp",
            link: "https://play.google.com/store/apps/details?id=com.feline.clipin"
        },
    ];

    return (
        <section id="case-studies" className={classes.CaseStudies}>
            <div className={classes.CaseStudiesContainer}>
                <div className={classes.CaseStudiesHeader} data-aos="fade-up">
                    <div>
                        <h3>Our Featured And Recent Works</h3>
                        <h1>Case Studies</h1>
                    </div>
                    <div></div>
                    <div className={classes.DomainNavigationContainer}>
                        <button className={classes.ViewDomainButton}>↙</button>
                        <a href="https://play.google.com/store/apps/dev?id=7333118628648613054" target="_blank" rel="noopener noreferrer" className={classes.ViewConsoleButton}>↗</a>
                    </div>
                </div>
                <div className={classes.CaseStudiesGrid} data-aos="zoom-in" data-aos-duration="1000">
                    <Carousel cols={3} hideArrow={true} showDots={true} dotColorActive={'#0080FB'} dotColorInactive={'#0080FB33'} autoplay={3000} loop containerStyle={{ paddingBottom: '40px' }}>
                        {caseStudies.map((study, index) => (
                            <Carousel.Item key={index}>
                                <div key={index} className={classes.CaseStudiesCard}>
                                    <img src={study.image} alt={study.title} />
                                    <div className={classes.CaseStudiesInfo}>
                                        <div className={classes.CaseStudiesText}>
                                            <p>{study.type}</p>
                                            <h2>{study.title}</h2>
                                        </div>
                                        <a href={study.link} target="_blank" rel="noopener noreferrer" className={classes.ViewProjectButton}>↗</a>
                                    </div>
                                </div>
                            </Carousel.Item>
                        ))}
                    </Carousel>
                </div>
            </div>
        </section>
    );

};

export default CaseStudies